import React, { useState } from 'react'
import ApiURL from '../modules/components/ApiURL'
import getToken from '../modules/components/Token'
import { checkLogin } from '../../../@WUM/templates/default/Auth/service/AuthService'

const AllIssue = () => {
    const [issue, setIssue] = useState([]) // Array instead of object

    React.useEffect(() => {
        let root = ApiURL()
        const fetchData = async () => {
            const result = await fetch(root + `Issue/`, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + getToken()
                }
            })
                .then((response) => response.json())
                .then((response) => {
                    checkLogin(response)
                    return response
                })
                .catch((err) => console.error(err))

            setIssue(result)
        }

        fetchData()
    }, [])

    return issue
}

export default AllIssue
